// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"30":"19639cbc11eeaa6c0261","489":"65006d52a62542a94d7e"}[chunkId] + ".js";
};